export enum UnitPaymentPurpose {
  None = 0,
  VendorPayment = 1,
  InternalPayment = 2
}
